export default __webpack_public_path__ + "static/marek_pixel-7df48a72e211b0b24e71eb70a6d4e6ca.jpg";